interface IconProps {
  fillColor: string
}

export const AgeVerificationIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="121"
        height="120"
        viewBox="0 0 121 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 60.5 11 A 2.50025 2.50025 0 0 0 59.630859 11.15625 L 27.53125 23.056641 A 2.50025 2.50025 0 0 0 27.521484 23.058594 C 24.131041 24.329975 22 27.599617 22 31.099609 L 22 57.5 C 22 79.650749 37.337323 97.458469 59.361328 108.72656 A 2.50025 2.50025 0 0 0 61.638672 108.72656 C 83.662677 97.458469 99 79.65075 99 57.5 L 99 31.099609 C 99 27.599617 96.868993 24.330022 93.478516 23.058594 A 2.50025 2.50025 0 0 0 93.46875 23.056641 L 61.369141 11.15625 A 2.50025 2.50025 0 0 0 60.5 11 z M 60.5 16.166016 L 91.724609 27.742188 C 93.132514 28.271448 94 29.600581 94 31.099609 L 94 57.5 C 94 76.973011 80.804234 92.89408 60.5 103.625 C 40.195766 92.89408 27 76.973011 27 57.5 L 27 31.099609 C 27 29.600581 27.867486 28.271448 29.275391 27.742188 L 29.277344 27.740234 L 60.5 16.166016 z M 4.5 43 A 2.5 2.5 0 0 0 2 45.5 A 2.5 2.5 0 0 0 4.5 48 L 12.5 48 A 2.5 2.5 0 0 0 15 45.5 A 2.5 2.5 0 0 0 12.5 43 L 4.5 43 z M 108.5 43 A 2.5 2.5 0 0 0 106 45.5 A 2.5 2.5 0 0 0 108.5 48 L 116.5 48 A 2.5 2.5 0 0 0 119 45.5 A 2.5 2.5 0 0 0 116.5 43 L 108.5 43 z M 78.369141 44.003906 A 2.5 2.5 0 0 0 76.642578 44.828125 L 55.904297 67.869141 L 45.767578 57.732422 A 2.5 2.5 0 0 0 42.232422 57.732422 A 2.5 2.5 0 0 0 42.232422 61.267578 L 54.232422 73.267578 A 2.50025 2.50025 0 0 0 57.857422 73.171875 L 80.357422 48.171875 A 2.5 2.5 0 0 0 80.171875 44.642578 A 2.5 2.5 0 0 0 78.369141 44.003906 z M 8.5 58 A 2.5 2.5 0 0 0 6 60.5 A 2.5 2.5 0 0 0 8.5 63 L 14.5 63 A 2.5 2.5 0 0 0 17 60.5 A 2.5 2.5 0 0 0 14.5 58 L 8.5 58 z M 106.5 58 A 2.5 2.5 0 0 0 104 60.5 A 2.5 2.5 0 0 0 106.5 63 L 112.5 63 A 2.5 2.5 0 0 0 115 60.5 A 2.5 2.5 0 0 0 112.5 58 L 106.5 58 z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
